<!--师资培训-->
<template>
    <div class="container">
        <div class="wel-box">
            <div class="course-container">
                <div class="left-menu-container">
                    <div class="menu-container">
                        <div @click="changeItem('2')" :class="activeItem==='2'?'menu-item menu-active':'menu-item'">培训任务</div>
                        <div @click="changeItem('3')" :class="activeItem==='3'?'menu-item menu-active':'menu-item'">培训课程</div>
                    </div>
                </div>
                <div v-if="activeItem==='2'"  class="right-content-container">
                    <app-tea-train-task :course-mode="this.activeMode"
                                    @change-mode="changeMode"/>
                </div>
                <!--课程-->
                <div v-if="activeItem==='3'"  class="right-content-container">
                    <app-page-train-course title="培训课程"
                                       courseType="1"
                                       :course-mode="this.activeMode"
                                       @change-mode="changeMode"/>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import {timestampToTime} from "@/utils/date";
import homeHead from "@/components/homeHead.vue";
import dataEmpty from "@/components/dataEmpty.vue";
import teaTrainMenu from "@/components/teaTrain/teaTrainMenu.vue";
import teaTrainStat from "@/components/teaTrain/teaTrainStat.vue";
import eduUserLesson from "@/components/eduResearch/eduUserLesson.vue";
import pageTrainCourse from "@/components/teaTrain/pageTrainCourse.vue";
import pageCourse from "@/components/resourceCentre/pageCourse.vue";
import {userLoginVerify} from "@/api/user/login";
import appTeaTrainTask from "@/components/app/train/appTeaTrainTask.vue";
import appPageTrainCourse from "@/components/app/train/appPageTrainCourse.vue";
export default {
    components: {
        pageCourse,
        eduUserLesson,
        dataEmpty,
        homeHead,
        teaTrainMenu,
        teaTrainStat,
        appTeaTrainTask,
        pageTrainCourse,
        appPageTrainCourse,
    },
    name: "appEduResearch",
    data() {
        return {
            pageMode:"page",
            detailMode:"detail",
            timestampToTime,
            activePath: "teacherTrainCenter",
            activeItem:"2",
            activeMode:"page",
        }
    },
    computed: {},
    watch: {},
    created() {
        if (this.$route.query.userId) {
            this.loginVerify(this.$route.query.userId)
        }
    },
    mounted() {

    },
    methods: {
        loginVerify(userId){
            userLoginVerify({ userId: userId }).then(res => {
                if (res.data.code === 1) {
                    const info = res.data.data;
                    this.$storage.set("userInfo", JSON.stringify(info.userInfo));
                    this.$storage.set("token", info.token);
                    this.$storage.set("role", info.role+'');
                    this.$storage.set("isAnalyse",info.isAnalyse+'');
                    this.$storage.set("isLogin", true);
                    this.activeItem = "2";
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        changeItem(item){
            this.activeItem = item;
            this.activeMode = this.pageMode;
        },
        changeMode(mode){
            this.activeMode = mode;
        }
    }
}
</script>
<style scoped>
.container {
    width: 100%;
    height: 100%;
    margin: 0;
    overflow-y: auto!important;
    overflow-x: hidden;
    background-color: #f1f1f1;
}
.wel-box {
    width:100vw;
    height: auto;
    overflow-y: auto!important;
    .top-box{
        display: flex;
        width: 100vw;
        height: 70px;
        background: #ff7f2e;
    }
}
.course-container{
    width: 100%;
    height: auto;
    border: 10px;
    box-sizing: border-box;
    display: flex;
}
.left-menu-container{
    width: 200px;
    height: auto;
    padding: 10px;
    box-sizing: border-box;
}
.menu-container{
    height: calc(100vh - 50px);
    background: #dfe4f7;
    padding-top: 15px;
    padding-bottom: 15px;
    border-radius: 10px;
    width: 180px!important;
    position: fixed;
    z-index: 999;
}
.menu-item{
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-indent: 15px;
    font-size: 15px;
    color: #707070;
    cursor: pointer;
}
.menu-active{
    background: #ff7f2e;
    color: #fff;
    //font-weight: bold;
}
.right-content-container{
    width: calc(100% - 200px);
    height: auto;
    padding: 10px;
    box-sizing: border-box;
}
</style>